/* Shared service dropdowns and responsive navigation for print, gallery and shop. */
(function () {
  'use strict';
  var header = document.querySelector('.site-header');
  if (!header) return;
  var nav = header.querySelector('.site-nav');
  var toggle = header.querySelector('.nav-toggle');
  if (!nav || !toggle) return;
  nav.id = nav.id || 'site-nav';
  function label() { nav.setAttribute('aria-label', document.documentElement.lang === 'en' ? 'Site navigation' : 'サイト内メニュー'); }
  label();
  toggle.setAttribute('aria-controls', nav.id);
  var menus = Array.from(nav.querySelectorAll('.service-menu'));
  var hoverPointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  var hoverCloseTimer;
  function hoverEnabled() { return hoverPointer.matches && !header.classList.contains('header-compact'); }
  function closeMenus(except) {
    menus.forEach(function (menu) { if (menu !== except) menu.open = false; });
  }
  function setNav(open) {
    header.classList.toggle('nav-open', open);
    document.body.classList.toggle('nav-locked', open);
    toggle.setAttribute('aria-expanded', String(open));
    if (!open) closeMenus();
  }
  toggle.addEventListener('click', function () { setNav(!header.classList.contains('nav-open')); });
  menus.forEach(function (menu) {
    var trigger = menu.querySelector('summary');
    menu.addEventListener('pointerenter', function (event) {
      if (event.pointerType === 'touch' || !hoverEnabled()) return;
      clearTimeout(hoverCloseTimer);
      closeMenus(menu); menu.open = true;
    });
    menu.addEventListener('pointerleave', function (event) {
      if (event.pointerType === 'touch' || !hoverEnabled()) return;
      clearTimeout(hoverCloseTimer);
      // Allow the pointer to cross the space between the label and full-width panel.
      hoverCloseTimer = setTimeout(function () {
        if (hoverEnabled() && !menu.matches(':hover') && !menu.contains(document.activeElement)) menu.open = false;
      }, 220);
    });
    trigger.addEventListener('click', function () { if (!menu.open) closeMenus(menu); });
    menu.addEventListener('toggle', function () { trigger.setAttribute('aria-expanded', String(menu.open)); });
    trigger.setAttribute('aria-expanded', String(menu.open));
    var closer = menu.querySelector('.service-close');
    if (closer) closer.addEventListener('click', function () { menu.open = false; trigger.focus(); });
    trigger.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowDown') return;
      event.preventDefault(); closeMenus(menu); menu.open = true;
      var first = menu.querySelector('.service-panel a'); if (first) first.focus();
    });
  });
  nav.addEventListener('click', function (event) {
    if (event.target.closest('a')) setNav(false);
  });
  document.addEventListener('click', function (event) { if (!header.contains(event.target)) setNav(false); });
  header.addEventListener('focusout', function () {
    requestAnimationFrame(function () {
      menus.forEach(function (menu) { if (!menu.contains(document.activeElement) && !(hoverEnabled() && menu.matches(':hover'))) menu.open = false; });
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      var openMenu = menus.find(function (menu) { return menu.open; });
      if (openMenu) { event.preventDefault(); openMenu.open = false; openMenu.querySelector('summary').focus(); }
      else if (header.classList.contains('nav-open')) { setNav(false); toggle.focus(); }
    }
    if (event.key === 'Tab' && header.classList.contains('nav-open')) {
      var stops = Array.from(header.querySelectorAll('a,button,summary,input:not([type="hidden"])')).filter(function (el) {
        return !el.disabled && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';
      });
      var first = stops[0], last = stops[stops.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  // Exact page links, separate from the active service indicator.
  nav.querySelectorAll('.service-panel a').forEach(function (link) {
    var url = new URL(link.href);
    if (url.origin === location.origin && url.pathname === location.pathname && !url.hash && !url.search) {
      link.setAttribute('aria-current', 'page');
    }
  });
  var scheduled = false;
  function navigationFits() {
    // Measure the flex row itself. scrollWidth also includes absolutely positioned
    // cart badges and open dropdowns, which do not take space in the header row.
    var style = getComputedStyle(nav);
    var items = Array.from(nav.children).filter(function (item) {
      return getComputedStyle(item).display !== 'none';
    });
    var required = items.reduce(function (width, item) {
      var itemStyle = getComputedStyle(item);
      return width + item.getBoundingClientRect().width +
        (parseFloat(itemStyle.marginLeft) || 0) + (parseFloat(itemStyle.marginRight) || 0);
    }, Math.max(0, items.length - 1) * (parseFloat(style.columnGap) || 0));
    var available = nav.getBoundingClientRect().width -
      (parseFloat(style.paddingLeft) || 0) - (parseFloat(style.paddingRight) || 0) -
      (parseFloat(style.borderLeftWidth) || 0) - (parseFloat(style.borderRightWidth) || 0);
    return required <= available + 1;
  }
  function layout() {
    scheduled = false;
    header.classList.remove('header-compact');
    var compact = window.matchMedia('(max-width:1120px)').matches || !navigationFits();
    header.classList.toggle('header-compact', compact);
    if (!compact) {
      if (header.classList.contains('nav-open')) setNav(false);
    }
    var height = Math.ceil(header.getBoundingClientRect().height) + 'px';
    if (document.documentElement.style.getPropertyValue('--header-height') !== height) {
      document.documentElement.style.setProperty('--header-height', height);
    }
  }
  function schedule() {
    if (!scheduled) { scheduled = true; requestAnimationFrame(layout); }
  }
  window.addEventListener('resize', schedule);
  document.addEventListener('toyobi:languagechange', function () { label(); schedule(); });
  new MutationObserver(schedule).observe(nav, {childList:true, subtree:true, characterData:true});
  if (window.ResizeObserver) new ResizeObserver(schedule).observe(header);
  if (document.fonts) document.fonts.ready.then(schedule);
  layout();
  // A service-name link visits its top page before opening the chosen directory.
  var url = new URL(location.href), requested = url.searchParams.get('service-menu');
  var requestedMenu = menus.find(function (menu) { return menu.dataset.service === requested && menu.classList.contains('service-current'); });
  if (requestedMenu) {
    url.searchParams.delete('service-menu');
    history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    if (header.classList.contains('header-compact')) setNav(true);
    closeMenus(requestedMenu); requestedMenu.open = true;
    var home = requestedMenu.querySelector('.service-home');
    if (home) home.focus({preventScroll:true});
  }
})();
